import { status } from '@/alas';
import { defineComponent, onMounted, reactive, computed } from '@vue/composition-api';
export default defineComponent({
    setup() {
        // ================
        //
        // state
        //
        let $ = reactive({
            farm: status.fetch('farm'),
            types: status.fetch('types'),
            cycle: status.fetch('cycle'),
            pictures: status.fetch('pictures'),
            show: {
                events: true,
                sunLine: false,
                rainLine: false,
                highTempLine: false,
                lowTempLine: false,
                priceLine: true,
                transLine: true,
                incomeLine: false,
                expenditureLine: false
            }
        });
        // ================
        //
        // computed
        //
        let fail = computed(() => $.pictures.o.fetchArchived.error || $.types.o.fetch.error);
        let loaded = computed(() => $.pictures.o.fetchArchived.done && $.types.o.fetch.done);
        let items = computed(() => $.pictures.items);
        // ================
        //
        // mounted
        //
        onMounted(() => {
            $.types.o.fetch.seek();
        });
        // ================
        //
        // done
        //
        return {
            $,
            fail,
            loaded,
            items
        };
    }
});
